import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Modal, Button, Icon } from 'antd';
import ReduxHoursDetails from 'containers/fe/ReduxHoursDetails.jsx';

import { aoIndexOf,
         aoObjectOf,
         calculateHours } from 'util/ArrayUtils.jsx';

function checkHours(registry, occurrences) {
  // recupero le forme didattiche previste nel registro
  const formeDid = [];
  for (let i = 0; i < registry.descFD.length; i++) {
    formeDid.push(registry.descFD[i].idFormaDidattica);
  }
  // controllo per ogni forma didattica prevista se le ore coincidono
  for (let i = 0; i < formeDid.length; i++) {
    const formeDidScheduled = aoObjectOf(registry.descFD, formeDid[i], 'idFormaDidattica');
    const formeDidRegistered = calculateHours(occurrences, formeDid[i]);
    console.log('ore previste:', formeDidScheduled.oreDocente);
    console.log('ore registrate:', formeDidRegistered);
    if (formeDidScheduled.oreDocente !== formeDidRegistered) {
      return false;
    }
  }
  return true;
}

function checkLastRow(occurrences) {
  console.warn('ho queste occorrenze da controllare:', occurrences);
  const actualData = moment();
  if (occurrences && occurrences.length > 0) {
    const lastLesson = occurrences[occurrences.length-1];
    console.warn('ultima data trovata:', lastLesson.data);
    return actualData.isBefore(lastLesson.data); 
    //return true;
  }
  return false;
}

function checkMissingArgument(occurrences) {
  if (aoIndexOf(occurrences, '', 'argomento') !== -1) {
    return false;
  }
  return true;
}

function checkIsEmpty(registry, occurrences) {
  console.log('sono arrivato al check di registro vuoto');
  if (registry.annotazioni === '' &&
      registry.oreGiustificate.length === 0 &&
      occurrences.length === 0) {
    return true;
  }
  return false;
}

class ModalCloseAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      cause: '',
    };
  }

  onSubmit = () => {
    if (this.props.trasversal) {
      this.openModal('closeTrasversal');
      return;
    }
    if (checkIsEmpty(this.props.registryInfo, this.props.occurrences)) {
      this.openModal('emptyRegistry');
      return;
    }
    if (checkMissingArgument(this.props.occurrences)) {
      // console.log('sono arrivato qui');
      if (checkLastRow(this.props.occurrences)) {
        // non passa il controllo sulla data dell'ultima lezione
        this.openModal('backToFuture');
        return;
      } // la data e ok, controllo ore svolte: se ok, procede alla chiusura
      if (checkHours(this.props.registryInfo, this.props.occurrences)) {
        // lancia chiamata di chiusura al WS
        this.props.closeRegistry(this.props.registryInfo.idRegistro);
      } else {
        // TODO:
        // chiedere a Gloria come ci dobbiamo comportare con la somma di ore
        // registrate e giustificate uguale a ore previste.
        // apre modale di avviso ore non coincidenti
        this.openModal('hoursNotOk');
      }
    } else {
      console.log('campi non compilati');
      // apro modale avviso campi da compilare
      this.openModal('fieldRequired');
    }
  }

  onConfirm = () => {
    this.props.closeRegistry(this.props.registryInfo.idRegistro);
    this.setState({
      modalIsOpen: false,
    });
  }

  openModal = (cause) => {
    this.setState({
      modalIsOpen: true,
      cause,
    });
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
  }

  render() {
    switch (this.state.cause) {
      case 'hoursNotOk':
        return (
          <div className="mg10 vmg10 inline-left">
            <Button
              onClick={() => this.onSubmit()}
              type="primary"
              size="large"
            >
              <Icon type="lock" />
              <span className="text-center">Invia</span>
            </Button>
            <Modal
              title="Anomalia ore registrate"
              visible={this.state.modalIsOpen}
              maskClosable={false}
              onCancel={() => this.closeModal()}
              onOk={() => this.onConfirm()}
              cancelText="Annulla"
              okText="Procedi comunque"
              okType="danger"
            >
              <p>Le ore registrate non corrispondono a quelle assegnate.</p>
              <ReduxHoursDetails toCheck />
              <p>Vuoi comunque procedere alla chiusura del registro?</p>
            </Modal>
          </div>
        );
      case 'emptyRegistry':
        return (
          <div className="mg10 vmg10 inline-left">
            <Button
              onClick={() => this.onSubmit()}
              type="primary"
              size="large"
            >
              <Icon type="lock" />
              <span className="text-center">Invia</span>
            </Button>
            <Modal
              title="Registro vuoto"
              visible={this.state.modalIsOpen}
              maskClosable={false}
              onCancel={() => this.closeModal()}
              footer={[<Button key="back" onClick={this.closeModal}>Ok</Button>]}
            >
              <p>Si prega di compilare il registro prima di chiuderlo.</p>
            </Modal>
          </div>
        );
      case 'closeTrasversal':
        return (
          <div className="mg10 vmg10 inline-left">
            <Button
              onClick={() => this.onSubmit()}
              type="primary"
              size="large"
            >
              <Icon type="lock" />
              <span className="text-center">Invia</span>
            </Button>
            <Modal
              title="Chiusura Registro Altre Attività"
              visible={this.state.modalIsOpen}
              maskClosable={false}
              onCancel={() => this.closeModal()}
              onOk={() => this.onConfirm()}
              cancelText="Annulla"
              okText="Procedi"
            >
              <p>Se si vuole chiudere il Registro Altre Attività cliccare su procedi.</p>
            </Modal>
          </div>
        );
      case 'backToFuture':
        return (
          <div className="mg10 vmg10 inline-left">
            <Button
              onClick={() => this.onSubmit()}
              type="primary"
              size="large"
            >
              <Icon type="lock" />
              <span className="text-center">Invia</span>
            </Button>
            <Modal
              title="Ultima data anteriore alla data di chiusura"
              visible={this.state.modalIsOpen}
              maskClosable={false}
              onCancel={() => this.closeModal()}
              footer={[<Button key="back" onClick={this.closeModal}>Ok</Button>]}
            >
              <p>Non puoi chiudere il registro prima dell'ultima data prevista dal calendario delle lezioni inserite.</p>
            </Modal>
          </div>
        );
      case 'fieldRequired':
      default:
        return (
          <div className="mg10 vmg10 inline-left">
            <Button
              onClick={() => this.onSubmit()}
              type="primary"
              size="large"
            >
              <Icon type="lock" />
              <span className="text-center">Invia</span>
            </Button>
            <Modal
              title="Dati non completi"
              visible={this.state.modalIsOpen}
              maskClosable={false}
              onCancel={() => this.closeModal()}
              footer={[<Button key="back" onClick={this.closeModal}>Ok</Button>]}
            >
              <p>Si prega di inserire l'argomento per tutte le attività registrate.</p>
            </Modal>
          </div>
        );
    }
  }
}

ModalCloseAlert.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  occurrences: PropTypes.arrayOf(PropTypes.object).isRequired,
  closeRegistry: PropTypes.func.isRequired,
  trasversal: PropTypes.bool,
};

export default ModalCloseAlert;
